// Single source of truth for the Ko-fi support account.
export const KOFI_HANDLE = "S6S61YRQE6";
export const KOFI_URL = `https://ko-fi.com/${KOFI_HANDLE}`;
